import { lazy } from "react";
import Loadable from "../components/Loadable";
const LearningNetworkSim = Loadable(lazy(() => import("../pages/Learning/LearningNetworkSim")));
const BuildWithPi = Loadable(lazy(() => import("../pages/Learning/BuildWithPi")));
const LearningImageGenerator = Loadable(lazy(() => import("../pages/Learning/LearningImageGenerator")));
const LearningIoTRoutingViz = Loadable(lazy(() => import("../pages/Learning/LearningIoTRoutingViz")));
const Profile = Loadable(lazy(() => import("../pages/Profile")));
const CreateCourseUser = Loadable(lazy(() => import("../pages/Profile/Courses/create-course")));
const EditCourseUser = Loadable(lazy(() => import("../pages/Profile/Courses/edit-course")));
const CreateCourseLearningMaterials  = Loadable(lazy(() => import("../pages/Profile/Courses/learning-materials")));

const CreateCourseLesson  = Loadable(lazy(() => import("../pages/Profile/Courses/create-course-lesson")));
const ViewCourseLesson  = Loadable(lazy(() => import("../pages/Profile/Courses/lessons")));
const EditCourseLesson  = Loadable(lazy(() => import("../pages/Profile/Courses/lessons/edit-lesson")));

const ViewEnrolledUsers = Loadable(lazy(() => import("../pages/Profile/Courses/view-grades/enrolled-users")));
const ViewGrades = Loadable(lazy(() => import("../pages/Profile/Courses/view-grades")));

const CreateQuiz = Loadable(lazy(() => import("../pages/Profile/Courses/quizzes/create-quiz")));
const CreateQuizQuestion = Loadable(lazy(() => import("../pages/Profile/Courses/quizzes/create-question")));
const ViewAllQuizzes = Loadable(lazy(() => import("../pages/Profile/Courses/quizzes/view-all")));
const EditQuiz = Loadable(lazy(() => import("../pages/Profile/Courses/quizzes/edit-quiz")));
const EditQuestions = Loadable(lazy(() => import("../pages/Profile/Courses/quizzes/edit-questions")));

const CreateProject = Loadable(lazy(() => import("../pages/Profile/Courses/projects/create-project")));
const CreateProjectQuestion = Loadable(lazy(() => import("../pages/Profile/Courses/projects/create-question")));
const ViewAllProjects = Loadable(lazy(() => import("../pages/Profile/Courses/projects/view-all")));
const EditProject = Loadable(lazy(() => import("../pages/Profile/Courses/projects/edit-project")));
const EditQuestionsProject = Loadable(lazy(() => import("../pages/Profile/Courses/projects/edit-questions")));

const LearningPython = Loadable(lazy(() => import("../pages/Learning/LearningPython")));


const NoDashboardRoutes = [ 
   
  { path: "/apps/cadsnode", element: <LearningNetworkSim /> }, 
  { path: "/apps/build-with-pi", element: <BuildWithPi /> }, 
  { path: "/apps/ai/image-generator", element: <LearningImageGenerator /> }, 
  { path: "/apps/iot/routing-visualizer", element: <LearningIoTRoutingViz /> }, 
  { path: "/profile", element: <Profile /> },
  { path: "/user/create-course", element: <CreateCourseUser /> },
  { path: "/user/edit-course/:courseId", element: <EditCourseUser /> },  
  { path: "/user/course/learning-materials/:courseSlug/:courseId", element: <CreateCourseLearningMaterials /> },

  { path: "/user/course/lessons/:courseSlug/:courseId", element: <CreateCourseLesson /> },
  { path: "/user/course/view-lessons/:courseId", element: <ViewCourseLesson /> },
  { path: "/user/edit-lesson/:courseId/:lessonId", element: <EditCourseLesson /> },

  { path: "/user/course/enrolled-users/:courseId", element: <ViewEnrolledUsers /> },
  { path: "/user/course/view-grades/:courseId/:userId", element: <ViewGrades /> },

  { path: "/user/course/create-quiz/:courseSlug/:courseId", element: <CreateQuiz /> },
  { path: "/user/course/quiz/create-question/:courseId/:quizId", element: <CreateQuizQuestion /> },
  { path: "/user/course/view-all-quizzes/:courseId", element: <ViewAllQuizzes /> },
  { path: "/user/edit-quiz/:courseId/:quizId", element: <EditQuiz /> },
  { path: "/user/edit-questions/:courseId/:quizId", element: <EditQuestions /> },
  /////////
  { path: "/user/course/create-project/:courseSlug/:courseId", element: <CreateProject /> },
  { path: "/user/course/project/create-question/:courseId/:projectId", element: <CreateProjectQuestion /> },
  { path: "/user/course/view-all-projects/:courseId", element: <ViewAllProjects /> },
  { path: "/user/edit-project/:courseId/:projectId", element: <EditProject /> },
  { path: "/user/edit-questions-project/:courseId/:projectId", element: <EditQuestionsProject /> },

  { path: "/apps/python", element: <LearningPython /> },



];

export default NoDashboardRoutes;


